import {Page} from 'utils/page-utils';
import CMSUtils from 'utils/cms';
import {PRISMIC_CUSTOM_TYPE} from 'utils/prismic-types';
import {initialState as searchRequestInitialState} from 'store/search-request/search-request-reducer';
import AppRatingAPI from 'api/app-rating';

const getInitialState = async ({state}) => {
    const [page, appRating] = await Promise.all([
        CMSUtils.getPageData({
            customType: PRISMIC_CUSTOM_TYPE.HOME_PAGE,
            slug: '',
            pageType: Page.HOME,
        }),
        AppRatingAPI.get(),
    ]);

    return {
        ...state,
        searchRequest: {
            ...searchRequestInitialState,
            pageType: Page.HOME,
        },
        page,
        appRating: {...appRating, isPending: false},
    };
};

export default getInitialState;
